import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { store } from './store/store';
import { Provider } from 'react-redux';
import * as serviceWorker from './serviceWorker';

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// Register service worker for PWA
// Change from unregister() to register() to enable PWA functionality
serviceWorker.register({
  onUpdate: (registration) => {
    console.log('New content available, please refresh.');
    // You can show a notification to the user here
    if (window.confirm('New version available! Reload to update?')) {
      window.location.reload();
    }
  },
  onSuccess: (registration) => {
    console.log('App is ready for offline use!');
    // You can show a success notification here
  }
});

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA

// PWA Install Prompt Handling
let deferredPrompt;
const installButton = document.createElement('button');
installButton.id = 'pwa-install-button';
installButton.style.cssText = `
  position: fixed;
  bottom: 20px;
  right: 20px;
  padding: 12px 24px;
  background-color: #4a90e2;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 16px;
  font-weight: bold;
  box-shadow: 0 4px 12px rgba(0,0,0,0.3);
  z-index: 9999;
  display: none;
`;

window.addEventListener('beforeinstallprompt', (e) => {
  // Prevent Chrome 67 and earlier from automatically showing the prompt
  e.preventDefault();
  // Stash the event so it can be triggered later
  deferredPrompt = e;

  // Show install button
  installButton.textContent = '📥 Install App';
  document.body.appendChild(installButton);

  installButton.addEventListener('click', async () => {
    // Hide install button
    installButton.style.display = 'none';

    // Show the prompt
    deferredPrompt.prompt();

    // Wait for the user to respond to the prompt
    const { outcome } = await deferredPrompt.userChoice;

    console.log(`User response to the install prompt: ${outcome}`);

    // Clear the deferredPrompt
    deferredPrompt = null;
  });
});

window.addEventListener('appinstalled', (evt) => {
  console.log('PWA app installed successfully!');
  // Remove install button if exists
  if (installButton.parentNode) {
    installButton.parentNode.removeChild(installButton);
  }
});
